(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var chrome = document.querySelector('[data-hf-chrome]');
  if (!chrome) return;
  var root = document.documentElement;
  var strip = chrome.querySelector('[data-hf-topstrip]');
  var bar = chrome.querySelector('[data-hf-bar]');
  var btn = chrome.querySelector('[data-hf-menu-btn]');
  var menu = chrome.querySelector('[data-hf-menu]');
  var label = chrome.querySelector('[data-hf-menu-label]');
  var phone = window.matchMedia('(max-width: 759.98px)');

  /* What stays pinned: the strip and the bar on desktop, the bar alone on a phone. The menu panel is
     left out so opening it never shifts anything else that is sticky. */
  function measure() {
    var stripH = strip ? strip.offsetHeight : 0;
    var barH = bar.offsetHeight + 1;
    root.style.setProperty('--hf-announce-h', stripH + 'px');
    root.style.setProperty('--hf-header-h', (phone.matches ? barH : stripH + barH) + 'px');
  }
  measure();
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(measure);
    ro.observe(bar);
    if (strip) ro.observe(strip);
  }
  phone.addEventListener('change', function () {
    measure();
    if (!phone.matches) setMenu(false);
  });

  function setMenu(open, returnFocus) {
    if (!btn || !menu) return;
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (label) label.textContent = btn.getAttribute(open ? 'data-label-close' : 'data-label-open');
    if (!open && returnFocus) btn.focus();
  }

  if (btn && menu) {
    btn.addEventListener('click', function () {
      setMenu(menu.hidden);
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) setMenu(false, true);
    });
  }

  var bag = chrome.querySelector('[data-hf-bag]');
  var count = bag ? bag.querySelector('[data-hf-cart-count]') : null;
  if (bag && count && window.MutationObserver) {
    var sync = function () {
      var n = parseInt(count.textContent, 10) || 0;
      count.hidden = n === 0;
      bag.setAttribute('aria-label', n > 0 ? bag.getAttribute('data-label-count').replace('{count}', n) : bag.getAttribute('data-label'));
    };
    new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('hf-how');
  if (!section || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var steps = [].slice.call(section.querySelectorAll('.hf-tree-door__stop'));
  var foot = section.querySelector('.hf-how__foot');
  var row = window.matchMedia('(min-width: 900px)').matches;
  section.classList.add('is-armed');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var play = e.target === section ? steps.concat(foot) : [e.target];
      play.forEach(function (el) { el.classList.add('is-in'); io.unobserve(el); });
      io.unobserve(e.target);
    });
  }, { threshold: 0.35 });
  (row ? [section] : steps.concat(foot)).forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bodies = document.querySelectorAll('[data-hf-prose]');
  if (!bodies.length) return;

  function slug(text) {
    return text.toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  bodies.forEach(function (body) {
    body.querySelectorAll('h2, h3').forEach(function (h) {
      if (!h.id) {
        var id = slug(h.textContent);
        if (id && !document.getElementById(id)) h.id = id;
      }
    });

    var questions = [].slice.call(body.children).filter(function (el) { return el.tagName === 'H3'; });
    questions.forEach(function (h3, i) {
      var answer = [];
      var next = h3.nextElementSibling;
      while (next && !/^(H1|H2|H3|HR)$/.test(next.tagName)) {
        answer.push(next);
        next = next.nextElementSibling;
      }
      var details = document.createElement('details');
      details.className = 'hf-util__qa';
      if (i === 0) details.open = true;
      var summary = document.createElement('summary');
      summary.className = 'hf-util__q';
      var panel = document.createElement('div');
      panel.className = 'hf-util__a';
      h3.parentNode.insertBefore(details, h3);
      summary.appendChild(h3);
      details.appendChild(summary);
      answer.forEach(function (el) { panel.appendChild(el); });
      details.appendChild(panel);
    });

    /* Consecutive questions share one card, as the design's FAQ does. */
    var group = null;
    [].slice.call(body.children).forEach(function (el) {
      if (el.tagName === 'DETAILS' && el.classList.contains('hf-util__qa')) {
        if (!group) {
          group = document.createElement('div');
          group.className = 'hf-util__qas';
          body.insertBefore(group, el);
        }
        group.appendChild(el);
      } else {
        group = null;
      }
    });
  });

  /* The ids above arrive after the browser has looked for the anchor, so go there now. */
  if (location.hash.length > 1) {
    var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (target) {
      var box = target.closest('details');
      if (box) box.open = true;
      target.scrollIntoView();
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-story-diary"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* The row only scrolls on a phone. Keyboard users get a tab stop on it then, and not before. */
  var rows = document.querySelectorAll('[data-hf-diary]');
  if (!rows.length) return;
  function sync() {
    rows.forEach(function (row) {
      if (row.scrollWidth > row.clientWidth + 1) { row.setAttribute('tabindex', '0'); } else { row.removeAttribute('tabindex'); }
    });
  }
  sync();
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(sync);
    rows.forEach(function (row) { ro.observe(row); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-story-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var path = document.querySelector('.hf-sp');
  if (!path || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  path.classList.add('is-armed');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.3 });
  [].forEach.call(path.querySelectorAll('.hf-sp__stop'), function (stop) { io.observe(stop); });
})();

  } catch(e) { console.error(e); }
})();
})();
